import { TextField } from '@mui/material'
import { form } from '../formState'
import { useTexts } from './useTexts'

type Props = {
  value: string
  onChange: (value: string) => void
}

export function ReasonField(props: Props) {
  const texts = useTexts()
  const { value, onChange } = props
  const isValid = value.length <= 30

  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()

  const formDisabled = submitting || disabled

  return (
    <TextField
      label={texts.label}
      placeholder={texts.placeholder}
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={formDisabled}
      data-testid="reason-for-orders_reason-txt"
      error={!isValid}
      helperText={isValid ? '' : texts.reasonsError}
    />
  )
}
